import React from 'react';
import {Flex, Heading, Text, Box} from '@spothero/ui';
import PropTypes from 'prop-types';
import {rightColumnItemStyleProps} from 'pages/parking-pass/styles';
import {PROPTYPE_RESERVATION_ACCESS_HOURS} from '@/proptypes/reservation-prop-types';
import {ALWAYS_OPEN_TYPE} from 'utils/spot';

const LocationAccessHours = ({accessHours, accessHoursComment}) => {
    if (!accessHours || accessHours.length === 0) {
        return null;
    }

    return (
        <Flex {...rightColumnItemStyleProps} alignItems="flex-start">
            <Heading lineHeight="1.4" as="h3" fontSize="base" marginBottom={2}>
                Location Access Hours
            </Heading>
            {accessHours.length === 1 &&
            accessHours[0].type === ALWAYS_OPEN_TYPE ? (
                <Text lineHeight="1.4">This facility is open 24/7.</Text>
            ) : (
                accessHours.map(period => {
                    return (
                        <Text
                            width="100%"
                            display="flex"
                            justifyContent="space-between"
                            key={`${period.days}${period.value}`}
                            lineHeight="1.4"
                        >
                            <Box as="span" className="day">
                                {period.days}
                            </Box>
                            <Box textTransform="capitalize" as="span">
                                {period.value}
                            </Box>
                        </Text>
                    );
                })
            )}
            {accessHoursComment ? (
                <Text
                    lineHeight="1.4"
                    color="text.secondary.light"
                    marginTop={2}
                >
                    {accessHoursComment}
                </Text>
            ) : null}
        </Flex>
    );
};

LocationAccessHours.propTypes = {
    accessHours: PROPTYPE_RESERVATION_ACCESS_HOURS,
    accessHoursComment: PropTypes.string,
};

export default LocationAccessHours;
